<div id="map-component" class="map-component" [class.expanded]="isMapExpanded">
  <div class="div-map-search anti-zoom">
    <input
      class="input-map-search"
      (keyup.enter)="getMapData(isSearch)"
      type="text"
      [(ngModel)]="searchValue"
      [placeholder]="'DASHBOARD.SALES_MANAGEMENT.MAP_PLACEHOLDER' | translate"
    />
    <div class="search-wrapper">
      <svg
        (click)="getMapData(isSearch)"
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.3952 12.9761C16.852 9.8209 16.63 5.25612 13.7295 2.3556C10.5887 -0.785201 5.49642 -0.785201 2.35561 2.3556C-0.785204 5.49642 -0.785204 10.5887 2.35561 13.7295C5.25614 16.63 9.82096 16.8519 12.9762 14.3952C12.9897 14.4106 13.0039 14.4257 13.0186 14.4403L17.2838 18.7055C17.6764 19.0982 18.313 19.0982 18.7056 18.7055C19.0981 18.3129 19.0981 17.6764 18.7056 17.2838L14.4404 13.0186C14.4256 13.0039 14.4105 12.9898 14.3952 12.9761ZM12.2426 3.75737C14.5858 6.10051 14.5858 9.89947 12.2426 12.2427C9.8995 14.5858 6.1005 14.5858 3.75736 12.2427C1.41421 9.89947 1.41421 6.10051 3.75736 3.75737C6.1005 1.41421 9.8995 1.41421 12.2426 3.75737Z"
          fill="#8F92A1"
        />
      </svg>
    </div>
  </div>
  <div class="map-container">
    <google-map
    [options]="mapOptions"
    (zoomChanged)="onZoomChange()"
    (boundsChanged)="mapBoundsChange()"
    (mapInitialized)="mapReady($event)"
    (idle)="mapIdleListener()"
    height="100%"
    width="100%"
    [zoom]="zoom"
    [center]="{lat:lat, lng: lng}"
    (mapClick)="onMapClick($event)"
  >
    <!-- <map-marker 
    *ngFor="let data of mapData"
    [position]="{lat: data.latitude , lng : data.longitude}"
    [label]="data.count.toString()"
    >
    </map-marker> -->
  </google-map>
  </div>

  <div *ngIf="isMapExpanded" class="switch-buttons-map">
    <app-switch-buttons initBtnClicked="map-btn" (buttonClicked)="switchButtonClicked($event)"></app-switch-buttons>
  </div>

  <div class="map-expand-option" (click)="toggleMap()">
    <img
      *ngIf="!isMapExpanded"
      src="../../../assets/icons/expand_screen.svg"
      alt="Expand screen icon"
    />
    <img
      *ngIf="isMapExpanded"
      src="../../../assets/icons/minimize_screen.svg"
      alt="Mimimize screen icon"
    />
  </div>

  <div
    id="streetview-small"
    [class.hide]="!isStreetViewVisible"
    #streetviewSmall
  >
    <div class="text">{{ "NO_STREET_VIEW_AVAILABLE" | translate }}</div>
    <div (click)="isStreetViewVisible = false" class="x-container">
      <img src="../../../assets/icons/close.svg" alt="Close icon" />
    </div>
  </div>
</div>
